import React from 'react';
import type ForgeFieldContextConfigPageType from '@atlassian/jira-spa-apps-forge-field-context-config/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyForgeFieldContextConfigPage = lazyForPaint<typeof ForgeFieldContextConfigPageType>(
	() =>
		import(
			/* webpackChunkName: "async-forge-spa-field-context-config", jiraSpaEntry: "async-forge-spa-field-context-config" */ '@atlassian/jira-spa-apps-forge-field-context-config'
		),
);

export const ForgeFieldContextConfigPage = () => (
	<LazyPage
		Page={LazyForgeFieldContextConfigPage}
		pageId="forge-spa-field-context-config"
		shouldShowSpinner
	/>
);

export default ForgeFieldContextConfigPage;
